import React from 'react';
import { Chip, Stack } from '@mui/material';
import { OrgUnitType } from '@retail/mgpris/config-types';
import { RemoveAllFiltersChip } from '../Chips';
import { useOrgUnitTypeLabel } from './useOrgUnitTypeLabel';

interface Props {
  options: OrgUnitType[];
  selected: OrgUnitType[];
  toggle: (orgUnitType: OrgUnitType) => void;
  clear: () => void;
}

export const OrgUnitTypeFilter: React.FC<Props> = ({ options, selected, toggle, clear }) => {
  const typeLabel = useOrgUnitTypeLabel();

  return (
    <Stack direction="row" gap={1} flexWrap="wrap" alignItems="center">
      {options.map((orgUnitType) => {
        const isSelected = selected.includes(orgUnitType);
        return (
          <Chip
            key={orgUnitType.getName()}
            size="small"
            clickable
            label={typeLabel(orgUnitType)}
            color={isSelected ? 'primary' : 'default'}
            variant={isSelected ? 'filled' : 'outlined'}
            onClick={() => toggle(orgUnitType)}
          />
        );
      })}
      {selected.length > 0 && <RemoveAllFiltersChip resetFilters={clear} />}
    </Stack>
  );
};
